var PreferredSignatureAlgorithms_1;
import { __decorate } from "tslib";
import { AsnProp, AsnArray, AsnType, AsnTypeTypes } from "@peculiar/asn1-schema";
import { AlgorithmIdentifier } from "@peculiar/asn1-x509";
export class PreferredSignatureAlgorithm {
    constructor(params = {}) {
        this.sigIdentifier = new AlgorithmIdentifier();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AlgorithmIdentifier })
], PreferredSignatureAlgorithm.prototype, "sigIdentifier", void 0);
__decorate([
    AsnProp({ type: AlgorithmIdentifier, optional: true })
], PreferredSignatureAlgorithm.prototype, "certIdentifier", void 0);
let PreferredSignatureAlgorithms = PreferredSignatureAlgorithms_1 = class PreferredSignatureAlgorithms extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, PreferredSignatureAlgorithms_1.prototype);
    }
};
PreferredSignatureAlgorithms = PreferredSignatureAlgorithms_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: PreferredSignatureAlgorithm })
], PreferredSignatureAlgorithms);
export { PreferredSignatureAlgorithms };
